import { render, staticRenderFns } from "./dialog-importfilemed.vue?vue&type=template&id=47a357f2&"
import script from "./dialog-importfilemed.vue?vue&type=script&lang=js&"
export * from "./dialog-importfilemed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports